<script lang="ts" setup>
import { onMounted } from "vue";
import { useFavoritesStore } from "@/services/favorites.store";
import "@/assets/css/icon-moon.css";
import "@/assets/css/app.css";
import "@/assets/css/flower-theme.css";

const favoritesStore = useFavoritesStore();
const WA_NUMBER = "905497786469";

onMounted(() => {
  favoritesStore.fetchFavoriteIds();
});
</script>

<template>
  <router-view />

  <!-- WhatsApp Floating Button -->
  <a
    :href="`https://wa.me/${WA_NUMBER}?text=Merhaba, sipariş hakkında bilgi almak istiyorum.`"
    target="_blank"
    rel="noopener"
    class="wa-float"
    aria-label="WhatsApp ile iletişime geç"
  >
    <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
      <path
        d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"
      />
      <path
        d="M12 0C5.373 0 0 5.373 0 12c0 2.136.561 4.14 1.535 5.874L.057 23.858a.5.5 0 0 0 .614.614l6.033-1.483A11.943 11.943 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.97 0-3.81-.563-5.37-1.535l-.386-.232-3.989.98.999-3.912-.254-.402A9.944 9.944 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"
      />
    </svg>
  </a>
</template>

<style lang="scss">
body .swal2-popup {
  font-size: 1.6rem !important;
}

main {
  min-height: calc(100vh - 80px);
}

.wa-float {
  position: fixed;
  // Çentikli telefonlarda alt home çubuğu / sağ kenar güvenli alanına saygı duy.
  bottom: calc(24px + env(safe-area-inset-bottom));
  right: calc(24px + env(safe-area-inset-right));
  z-index: 9999;
  width: 56px;
  height: 56px;
  background: #25d366;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 16px rgba(37, 211, 102, 0.45);
  transition: all 0.2s ease;
  text-decoration: none;

  &:hover {
    transform: scale(1.1);
    box-shadow: 0 6px 20px rgba(37, 211, 102, 0.6);
  }

  @media (max-width: 768px) {
    bottom: calc(16px + env(safe-area-inset-bottom));
    right: calc(16px + env(safe-area-inset-right));
    width: 50px;
    height: 50px;
  }
}

// Mobil filtre drawer açıkken WhatsApp butonu ekranı/Uygula butonunu
// kapatmasın diye gizlenir.
body.cp-drawer-open .wa-float {
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
}
</style>
